const INTENT_KEY = "coachli:oauth-return-intent";
const INTENT_TTL_MS = 30 * 60 * 1000;

type OAuthReturnIntent = {
  returnPath: string;
  ts: number;
};

export function writeOAuthReturnIntent(returnPath: string): void {
  if (typeof window === "undefined" || typeof sessionStorage === "undefined") {
    return;
  }
  const intent: OAuthReturnIntent = {returnPath, ts: Date.now()};
  sessionStorage.setItem(INTENT_KEY, JSON.stringify(intent));
}

export function consumeOAuthReturnIntent(): string | null {
  if (typeof window === "undefined" || typeof sessionStorage === "undefined") {
    return null;
  }
  const raw = sessionStorage.getItem(INTENT_KEY);
  sessionStorage.removeItem(INTENT_KEY);
  if (!raw) {
    return null;
  }
  try {
    const parsed = JSON.parse(raw) as OAuthReturnIntent;
    if (Date.now() - parsed.ts > INTENT_TTL_MS) {
      return null;
    }
    return parsed.returnPath ?? null;
  } catch {
    return null;
  }
}
